export const CREW_DELETE_DEACTIVATE_MODES = {
  NO_EXPERIENCES: "no_experiences",
  ASSIGNED_EXPERIENCES_NO_ACTIVE_BOOKING: "assigned_experiences_no_active_booking",
  FULLY_SUBSTITUTABLE: "fully",
  PARTIALLY_SUBSTITUTABLE: "partially"
}

export const MAX_DESCRIPTION_LENGTH = 200
